import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getCuti = createAsyncThunk(
    "cuti/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSetupCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertCuti = createAsyncThunk(
    "cuti/insert",
    async ({namaCuti, golonganID, tipeKaryawanID, jumlahCuti, tiketPesawat}, thunkAPI) => {
        let formData = new FormData();
        formData.append("namaCuti", namaCuti);
        formData.append("golonganID", golonganID);
        formData.append("tipeKaryawanID", tipeKaryawanID);
        formData.append("jumlahCuti", jumlahCuti);
        formData.append("tiketPesawat", tiketPesawat);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertSetupCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateCuti = createAsyncThunk(
    "cuti/update",
    async ({setupCutiID, namaCuti, golonganID, tipeKaryawanID, jumlahCuti, tiketPesawat, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("setupCutiID", setupCutiID);
        formData.append("namaCuti", namaCuti);
        formData.append("golonganID", golonganID);
        formData.append("tipeKaryawanID", tipeKaryawanID);
        formData.append("jumlahCuti", jumlahCuti);
        formData.append("tiketPesawat", tiketPesawat);
        formData.append("status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateSetupCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

const initialState = {
    message: "",
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const cutiSlice = createSlice({
    name: "cuti",
    initialState,
    reducers: {},
    extraReducers: {
        [getCuti.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getCuti.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getCuti.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertCuti.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertCuti.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertCuti.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateCuti.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateCuti.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateCuti.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const cutiSelector = (state) => state.cuti;
